import TimelineComponent from './TimeLine';

function Descargas({ ...props }: any) {
    return <TimelineComponent {...props} />;
}

export default Descargas;
